module.exports = __webpack_public_path__ + "media/images/icons/icon-arrow-back-3c08e9d270fb376a9bb9e047823639ea.svg";